export const ACCEPT = Object.freeze({
  Images: {
    'image/jpeg': [],
    'image/png': [],
    'image/jpg': [],
  },
});
